<template>
  <div class="st-landing-root">

    <!-- NAVBAR -->
    <nav class="st-nav" :class="{ 'nav-scrolled': isScrolled }">
      <div class="container d-flex align-items-center justify-content-between py-2">
        <a href="javascript:void(0)" @click="$router.push('/')" class="st-brand d-flex align-items-center">
          <img src="assets/images/simi_trac_logo.png" alt="Simi Trac" style="height:40px;" />
        </a>
        <div class="d-none d-lg-flex align-items-center">
          <a href="#modules" class="st-nav-link" @click.prevent="scrollTo('modules')">Modules</a>
          <a href="#how-it-works" class="st-nav-link" @click.prevent="scrollTo('how-it-works')">How It Works</a>
          <a href="#attendance" class="st-nav-link" @click.prevent="scrollTo('attendance')">Attendance</a>
          <a href="#pricing" class="st-nav-link" @click.prevent="scrollTo('pricing')">Pricing</a>
          <a href="#faq" class="st-nav-link" @click.prevent="scrollTo('faq')">FAQ</a>
          <span class="st-nav-divider"></span>
          <template v-if="isLoggedIn">
            <a v-if="isPlatformOwner" href="javascript:void(0)" @click="$router.push('/admin')" class="btn btn-sm st-btn-primary me-2"><i class="mdi mdi-shield-crown me-1"></i>Platform Admin</a>
            <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="btn btn-sm st-btn-outline me-2"><i class="mdi mdi-view-dashboard me-1"></i>Dashboard</a>
            <div class="st-user-pill" @click="showUserDrop=!showUserDrop">
              <div class="st-avatar">{{ userInitials }}</div>
              <span class="st-user-name">{{ userName }}</span>
              <i class="mdi mdi-chevron-down" style="color:#8BA4C4;font-size:14px;"></i>
            </div>
            <div v-if="showUserDrop" class="st-user-drop">
              <a v-if="isPlatformOwner" href="javascript:void(0)" @click="$router.push('/admin');showUserDrop=false" class="st-drop-item" style="color:#4FC3F7;font-weight:700;"><i class="mdi mdi-shield-crown me-2"></i>Platform Admin</a>
              <a href="javascript:void(0)" @click="$router.push('/dashboard');showUserDrop=false" class="st-drop-item"><i class="mdi mdi-view-dashboard me-2"></i>Dashboard</a>
              <a href="javascript:void(0)" @click="$router.push('/students');showUserDrop=false" class="st-drop-item"><i class="mdi mdi-account-school me-2"></i>Students</a>
              <div style="border-top:1px solid #1A3A6A;margin:6px 0;"></div>
              <a href="javascript:void(0)" @click="logout" class="st-drop-item" style="color:#FF6B6B;"><i class="mdi mdi-logout me-2"></i>Sign Out</a>
            </div>
          </template>
          <template v-else>
            <a href="javascript:void(0)" @click="$router.push('/login')" class="btn btn-sm st-btn-outline me-2">Sign In</a>
            <a href="javascript:void(0)" @click="$router.push('/register')" class="btn btn-sm st-btn-primary">Get Started Free</a>
          </template>
        </div>
        <button class="btn btn-link text-white d-lg-none p-0" @click="mobileMenuOpen = !mobileMenuOpen">
          <i class="mdi mdi-menu" style="font-size:28px;" v-if="!mobileMenuOpen"></i>
          <i class="mdi mdi-close" style="font-size:28px;" v-else></i>
        </button>
      </div>
      <!-- Mobile Menu -->
      <div v-if="mobileMenuOpen" class="st-mobile-menu d-lg-none">
        <a href="#modules" class="st-mobile-link" @click.prevent="scrollTo('modules');mobileMenuOpen=false">Modules</a>
        <a href="#how-it-works" class="st-mobile-link" @click.prevent="scrollTo('how-it-works');mobileMenuOpen=false">How It Works</a>
        <a href="#attendance" class="st-mobile-link" @click.prevent="scrollTo('attendance');mobileMenuOpen=false">Attendance</a>
        <a href="#pricing" class="st-mobile-link" @click.prevent="scrollTo('pricing');mobileMenuOpen=false">Pricing</a>
        <a href="#faq" class="st-mobile-link" @click.prevent="scrollTo('faq');mobileMenuOpen=false">FAQ</a>
        <div class="pt-3">
          <template v-if="isLoggedIn">
            <a v-if="isPlatformOwner" href="javascript:void(0)" @click="$router.push('/admin');mobileMenuOpen=false" class="btn st-btn-primary w-100 mb-2"><i class="mdi mdi-shield-crown me-1"></i>Platform Admin</a>
            <a href="javascript:void(0)" @click="$router.push('/dashboard');mobileMenuOpen=false" class="btn st-btn-outline w-100 mb-2"><i class="mdi mdi-view-dashboard me-1"></i>Dashboard</a>
            <a href="javascript:void(0)" @click="logout" class="btn btn-outline-danger w-100"><i class="mdi mdi-logout me-1"></i>Sign Out</a>
          </template>
          <template v-else>
            <a href="javascript:void(0)" @click="$router.push('/login');mobileMenuOpen=false" class="btn st-btn-outline w-100 mb-2">Sign In</a>
            <a href="javascript:void(0)" @click="$router.push('/register');mobileMenuOpen=false" class="btn st-btn-primary w-100">Get Started Free</a>
          </template>
        </div>
      </div>
    </nav>

    <!-- ============ HERO ============ -->
    <section class="st-hero">
      <div class="st-hero-grid"></div>
      <div class="st-hero-glow"></div>
      <div class="container position-relative" style="z-index:2;">
        <div class="row align-items-center" style="min-height:calc(100vh - 80px);padding-top:80px;">
          <div class="col-lg-7">
            <div class="mb-3">
              <span class="st-hero-badge"><i class="mdi mdi-shield-check me-1"></i> Trusted by Schools Across East Africa</span>
            </div>
            <h1 class="st-hero-title">Track Students.<br/><span class="st-hero-accent">Empower Parents.</span></h1>
            <p class="st-hero-sub mt-3">Simi Trac is Africa's all-in-one school attendance, transport tracking, cashless payments, and student management platform. GPS-tagged SMS on every tap. Parents know exactly where their child is.</p>
            <div class="mt-4 d-flex flex-wrap gap-2">
              <a href="javascript:void(0)" @click="$router.push('/register')" class="btn st-btn-primary btn-lg"><i class="mdi mdi-rocket-launch me-1"></i> Register Your School</a>
              <a href="#how-it-works" class="btn st-btn-ghost btn-lg" @click.prevent="scrollTo('how-it-works')"><i class="mdi mdi-play-circle me-1"></i> See How It Works</a>
            </div>
            <div class="st-hero-stats mt-5">
              <div class="st-hero-stat">
                <div class="st-hero-stat-num">500</div>
                <div class="st-hero-stat-lbl">Free SMS</div>
              </div>
              <div class="st-hero-stat-div"></div>
              <div class="st-hero-stat">
                <div class="st-hero-stat-num">5s</div>
                <div class="st-hero-stat-lbl">Card Tap</div>
              </div>
              <div class="st-hero-stat-div"></div>
              <div class="st-hero-stat">
                <div class="st-hero-stat-num">GPS</div>
                <div class="st-hero-stat-lbl">Every SMS</div>
              </div>
              <div class="st-hero-stat-div"></div>
              <div class="st-hero-stat">
                <div class="st-hero-stat-num">24/7</div>
                <div class="st-hero-stat-lbl">Tracking</div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 d-none d-lg-flex justify-content-center">
            <div class="st-phone-mockup">
              <div class="st-phone-notch"></div>
              <div class="st-phone-screen">
                <div class="st-phone-header">
                  <i class="mdi mdi-map-marker" style="color:#2E86DE;"></i>
                  <span style="color:#fff;font-size:13px;font-weight:600;">Live Attendance</span>
                  <span class="st-phone-time">{{ currentTime }}</span>
                </div>
                <div v-for="(tap, i) in phoneTaps" :key="i" class="st-phone-tap" :style="{animationDelay: (i*0.3)+'s'}">
                  <div class="st-phone-tap-icon" :style="{background: tap.bg}">
                    <i :class="tap.icon" :style="{color: tap.color}"></i>
                  </div>
                  <div class="flex-fill">
                    <div style="color:#E8EDF4;font-size:12px;font-weight:600;">{{ tap.title }}</div>
                    <div style="color:#8BA4C4;font-size:10px;">{{ tap.sub }}</div>
                  </div>
                  <div style="color:#2E86DE;font-size:10px;font-weight:600;">{{ tap.time }}</div>
                </div>
                <div class="st-phone-map">
                  <i class="mdi mdi-map-marker-radius" style="font-size:40px;color:#2E86DE;opacity:.3;"></i>
                  <div style="color:#8BA4C4;font-size:10px;margin-top:4px;">GPS Location Verified</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ TRUSTED BY ============ -->
    <section class="st-trusted">
      <div class="container text-center">
        <p class="st-trusted-label">BUILT FOR EVERY SCHOOL TYPE</p>
        <div class="st-trusted-row">
          <div class="st-trusted-item" v-for="t in schoolTypes" :key="t.label">
            <i :class="t.icon" class="st-trusted-icon"></i>
            <span>{{ t.label }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ PROBLEM / SOLUTION ============ -->
    <section class="st-section" style="background:#060D1A;">
      <div class="container">
        <div class="row">
          <div class="col-lg-5">
            <span class="st-section-label">THE PROBLEM</span>
            <h2 class="st-section-title mt-2">Schools Are Running<br/><span class="st-hero-accent">Blind</span></h2>
            <p class="st-section-sub mt-3">Cash gets lost. Parents have zero visibility. No one knows if a child arrived at school, boarded the bus, or is safe. School fees collection is a spreadsheet nightmare.</p>
          </div>
          <div class="col-lg-7">
            <div class="row g-3 mt-3 mt-lg-0">
              <div class="col-sm-6" v-for="(prob, i) in problems" :key="i">
                <div class="st-problem-card">
                  <div class="st-problem-icon" :style="{background: prob.bg}">
                    <i :class="prob.icon" :style="{color: prob.color}"></i>
                  </div>
                  <h6 class="st-problem-title">{{ prob.title }}</h6>
                  <p class="st-problem-desc">{{ prob.desc }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ MODULES ============ -->
    <section class="st-section" id="modules">
      <div class="container">
        <div class="text-center">
          <span class="st-section-label">PLATFORM MODULES</span>
          <h2 class="st-section-title mt-2">One Platform. Everything Connected.</h2>
          <p class="st-section-sub mx-auto" style="max-width:640px;">From attendance tracking to cashless dining, school fees to financial literacy — Simi Trac replaces 10 separate systems with one.</p>
        </div>
        <div class="row g-4 mt-4">
          <div class="col-lg-4 col-md-6" v-for="(mod, i) in modules" :key="i">
            <div class="st-module-card" @mouseenter="activeModule=i" @mouseleave="activeModule=null">
              <div class="st-module-icon" :style="{background: mod.bg}">
                <i :class="mod.icon" :style="{color: mod.color, fontSize: '24px'}"></i>
              </div>
              <h5 class="st-module-title">{{ mod.title }}</h5>
              <p class="st-module-desc">{{ mod.desc }}</p>
              <div class="st-module-tags">
                <span class="st-module-tag" v-for="tag in mod.tags" :key="tag">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ HOW IT WORKS ============ -->
    <section class="st-section" id="how-it-works" style="background:#060D1A;">
      <div class="container">
        <div class="text-center">
          <span class="st-section-label">HOW IT WORKS</span>
          <h2 class="st-section-title mt-2">Simple Flows. Powerful Outcomes.</h2>
        </div>
        <div class="mt-5">
          <div class="st-flow-tabs mb-4 d-flex justify-content-center flex-wrap gap-2">
            <button v-for="(flow, fi) in flows" :key="fi" class="st-flow-tab" :class="{active: activeFlow===fi}" @click="activeFlow=fi">
              <i :class="flow.icon" class="me-1"></i> {{ flow.title }}
            </button>
          </div>
          <div class="row g-3 justify-content-center">
            <div class="col-lg-3 col-md-6" v-for="(step, si) in flows[activeFlow].steps" :key="si">
              <div class="st-step-card">
                <div class="st-step-number">{{ si + 1 }}</div>
                <div class="st-step-icon">
                  <i :class="step.icon" style="font-size:28px;color:#2E86DE;"></i>
                </div>
                <h6 class="st-step-title">{{ step.title }}</h6>
                <p class="st-step-desc">{{ step.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ ATTENDANCE GPS ============ -->
    <section class="st-section" id="attendance">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6">
            <span class="st-section-label">ATTENDANCE & GPS</span>
            <h2 class="st-section-title mt-2">Every Tap. Every Location.<br/><span class="st-hero-accent">Every Parent Notified.</span></h2>
            <p class="st-section-sub mt-3">When a student taps their card at the gate, classroom, bus, or event — parents receive an SMS with a clickable Google Maps link showing the exact location. In real time.</p>
            <div class="mt-4">
              <div class="st-gps-item" v-for="(gps, gi) in gpsTaps" :key="gi">
                <div class="st-gps-dot" :class="{'active': gi < 3}"></div>
                <div class="flex-fill">
                  <div class="st-gps-title">{{ gps.title }}</div>
                  <div class="st-gps-sms">{{ gps.sms }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 text-center mt-4 mt-lg-0">
            <div class="st-sms-preview">
              <div class="st-sms-header">
                <i class="mdi mdi-message-text" style="color:#2E86DE;"></i>
                <span>Simi Trac SMS</span>
              </div>
              <div class="st-sms-bubble">
                <p class="mb-1">John arrived at <strong>Greenfield School</strong> at <strong>7:38 AM</strong>.</p>
                <a href="javascript:void(0)" class="st-sms-link"><i class="mdi mdi-map-marker me-1"></i>View on Google Maps</a>
                <div class="st-sms-time">7:38 AM</div>
              </div>
              <div class="st-sms-bubble">
                <p class="mb-1">John boarded <strong>Bus 2 (Karen Route)</strong> at <strong>3:10 PM</strong>.</p>
                <a href="javascript:void(0)" class="st-sms-link"><i class="mdi mdi-bus me-1"></i>Track Bus Location</a>
                <div class="st-sms-time">3:10 PM</div>
              </div>
              <div class="st-sms-bubble st-sms-alert">
                <p class="mb-0"><i class="mdi mdi-alert me-1"></i> John has not arrived at school today. Please follow up.</p>
                <div class="st-sms-time">8:15 AM</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ CUSTOMER JOURNEY ============ -->
    <section class="st-section" style="background:#060D1A;">
      <div class="container">
        <div class="text-center">
          <span class="st-section-label">CUSTOMER JOURNEY</span>
          <h2 class="st-section-title mt-2">A Child Who Joins Simi Stays for <span class="st-hero-accent">15+ Years</span></h2>
        </div>
        <div class="row g-4 mt-4 justify-content-center">
          <div class="col-lg-4 col-md-6" v-for="(j, ji) in journey" :key="ji">
            <div class="st-journey-card">
              <div class="st-journey-bar" :style="{background: j.color}"></div>
              <div class="st-journey-stage">{{ j.stage }}</div>
              <div class="st-journey-label">{{ j.label }}</div>
              <div class="st-journey-module" :style="{background: j.color}">{{ j.module }}</div>
              <ul class="st-journey-list">
                <li v-for="item in j.items" :key="item">{{ item }}</li>
              </ul>
            </div>
          </div>
        </div>
        <p class="text-center mt-4" style="color:#8BA4C4;font-style:italic;">One wallet, one app, one trusted brand — from first day of school to graduation day.</p>
      </div>
    </section>

    <!-- ============ PRICING ============ -->
    <section class="st-section" id="pricing">
      <div class="container">
        <div class="text-center">
          <span class="st-section-label">PRICING</span>
          <h2 class="st-section-title mt-2">Three Revenue Streams. <span class="st-hero-accent">Zero Barrier to Entry.</span></h2>
          <p class="st-section-sub mx-auto" style="max-width:560px;">Register for free. Get 500 SMS credits instantly. Start using all modules immediately. Pay only when you scale.</p>
        </div>
        <div class="row g-4 mt-4 justify-content-center">
          <div class="col-lg-4 col-md-6" v-for="(plan, pi) in pricingPlans" :key="pi">
            <div class="st-pricing-card" :class="{'st-pricing-pop': plan.popular}">
              <div v-if="plan.popular" class="st-pricing-badge">MOST POPULAR</div>
              <div class="st-pricing-header" :style="{background: plan.headerBg}">
                <h4 class="st-pricing-name">{{ plan.name }}</h4>
                <div class="st-pricing-price">{{ plan.price }}</div>
                <div class="st-pricing-period">{{ plan.period }}</div>
              </div>
              <div class="st-pricing-body">
                <div class="st-pricing-feature" v-for="f in plan.features" :key="f">
                  <i class="mdi mdi-check-circle" style="color:#10B981;"></i>
                  <span>{{ f }}</span>
                </div>
                <a href="javascript:void(0)" @click="$router.push('/register')" class="btn w-100 mt-3" :class="plan.popular ? 'st-btn-primary' : 'st-btn-outline'">{{ plan.cta }}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="st-pricing-example mt-4">
          <i class="mdi mdi-calculator me-2"></i>
          Example: 1 school × 500 students × 3 terms × KSh 1,000 = <strong>KSh 1.5M / year</strong> from attendance alone + platform fee + SMS revenue
        </div>
      </div>
    </section>

    <!-- ============ FAQ ============ -->
    <section class="st-section" id="faq" style="background:#060D1A;">
      <div class="container">
        <div class="text-center">
          <span class="st-section-label">FAQ</span>
          <h2 class="st-section-title mt-2">Frequently Asked Questions</h2>
        </div>
        <div class="row justify-content-center mt-4">
          <div class="col-lg-8">
            <div class="st-faq-item" v-for="(fq, fi) in faqs" :key="fi" @click="activeFaq = activeFaq === fi ? null : fi">
              <div class="st-faq-q">
                <span>{{ fq.q }}</span>
                <i class="mdi" :class="activeFaq===fi ? 'mdi-chevron-up' : 'mdi-chevron-down'"></i>
              </div>
              <div class="st-faq-a" v-if="activeFaq === fi">{{ fq.a }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ CTA ============ -->
    <section class="st-cta">
      <div class="container text-center">
        <h2 class="st-cta-title">Ready to Transform Your School?</h2>
        <p class="st-cta-sub">Register for free. Get 500 SMS credits. Start tracking in minutes.</p>
        <div class="mt-4 d-flex justify-content-center flex-wrap gap-3">
          <a href="javascript:void(0)" @click="$router.push('/register')" class="btn st-btn-primary btn-lg"><i class="mdi mdi-rocket-launch me-1"></i> Register Your School — Free</a>
          <a href="javascript:void(0)" class="btn st-btn-ghost btn-lg"><i class="mdi mdi-phone me-1"></i> Talk to Sales</a>
        </div>
      </div>
    </section>

    <!-- ============ FOOTER ============ -->
    <footer class="st-footer">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-4">
            <img src="assets/images/simi_trac_logo.png" alt="Simi Trac" style="height:48px;" />
            <p class="st-footer-desc mt-3">Save Smart, Spend Smart. Africa's all-in-one school attendance, transport tracking, and campus financial ecosystem.</p>
            <div class="st-footer-socials">
              <a href="#" class="st-social-icon"><i class="mdi mdi-twitter"></i></a>
              <a href="#" class="st-social-icon"><i class="mdi mdi-facebook"></i></a>
              <a href="#" class="st-social-icon"><i class="mdi mdi-linkedin"></i></a>
              <a href="#" class="st-social-icon"><i class="mdi mdi-instagram"></i></a>
            </div>
          </div>
          <div class="col-6 col-lg-2" v-for="col in footerColumns" :key="col.heading">
            <h6 class="st-footer-heading">{{ col.heading }}</h6>
            <a v-for="link in col.links" :key="link.text" href="javascript:void(0)" @click="$router.push(link.url)" class="st-footer-link">{{ link.text }}</a>
          </div>
          <div class="col-6 col-lg-2">
            <h6 class="st-footer-heading">Contact Us</h6>
            <a href="mailto:info@simitrac.co.ke" class="st-footer-link"><i class="mdi mdi-email me-1"></i>info@simitrac.co.ke</a>
            <a href="https://wa.me/254720680555" class="st-footer-link"><i class="mdi mdi-whatsapp me-1"></i>+254 720 680 555</a>
            <a href="tel:+254720680555" class="st-footer-link"><i class="mdi mdi-phone me-1"></i>+254 720 680 555</a>
            <a href="https://simitrac.co.ke" class="st-footer-link"><i class="mdi mdi-web me-1"></i>simitrac.co.ke</a>
          </div>
        </div>
        <div class="st-footer-bottom">
          <span>&copy; {{ currentYear }} Simi Trac. All rights reserved.</span>
          <span>simitrac.co.ke</span>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
export default {
  name: "LandingPage",
  data() {
    return {
      isScrolled: false,
      mobileMenuOpen: false,
      showUserDrop: false,
      isLoggedIn: false,
      isPlatformOwner: false,
      userName: '',
      userInitials: '',
      activeModule: null,
      activeFlow: 0,
      activeFaq: null,

      schoolTypes: [
        { icon: 'mdi mdi-school', label: 'Primary Schools' },
        { icon: 'mdi mdi-book-education', label: 'High Schools' },
        { icon: 'mdi mdi-city-variant', label: 'Universities' },
        { icon: 'mdi mdi-home-group', label: 'Boarding Schools' },
        { icon: 'mdi mdi-domain', label: 'Colleges' },
      ],

      problems: [
        { icon: 'mdi mdi-cash-remove', title: 'Cash Chaos', desc: 'Students carry cash daily — theft, loss, and zero accountability.', bg: 'rgba(255,107,107,.12)', color: '#FF6B6B' },
        { icon: 'mdi mdi-eye-off', title: 'Zero Visibility', desc: 'Parents have no idea if their child arrived, or how they spent money.', bg: 'rgba(255,193,7,.12)', color: '#FFC107' },
        { icon: 'mdi mdi-map-marker-off', title: 'No Safety Tracking', desc: 'No one knows if a child boarded the bus or reached home safely.', bg: 'rgba(46,134,222,.12)', color: '#2E86DE' },
        { icon: 'mdi mdi-file-document-remove', title: 'Paper Nightmares', desc: 'Fee collection, grades, attendance — all done on paper or fragmented spreadsheets.', bg: 'rgba(16,185,129,.12)', color: '#10B981' },
      ],

      modules: [
        { icon: 'mdi mdi-map-marker-radius', title: 'Attendance & GPS', desc: 'Gate, classroom, bus, and event tracking with real-time GPS SMS to parents on every tap.', bg: 'rgba(46,134,222,.15)', color: '#2E86DE', tags: ['GPS SMS', 'Smart Alerts', 'Bus Tracking'] },
        { icon: 'mdi mdi-credit-card-wireless', title: 'Dining Wallet', desc: 'Students tap RFID cards to pay at any dining hall. Under 5 seconds. Works across all campuses.', bg: 'rgba(16,185,129,.15)', color: '#10B981', tags: ['Card Tap', 'M-Pesa Top-Up', 'Multi-Campus'] },
        { icon: 'mdi mdi-wallet', title: 'Pocket Money', desc: 'Parents load money, set spending limits, get SMS on every purchase. Freeze wallet instantly.', bg: 'rgba(245,158,11,.15)', color: '#F59E0B', tags: ['Parental Controls', 'Spend Limits', 'Real-Time Alerts'] },
        { icon: 'mdi mdi-piggy-bank', title: 'Home Finance', desc: 'Chores earn money. Savings goals tracked visually. Spend/Save/Give buckets. Works year-round.', bg: 'rgba(168,85,247,.15)', color: '#A855F7', tags: ['Chores', 'Savings Goals', 'Financial Literacy'] },
        { icon: 'mdi mdi-cash-register', title: 'School Fees', desc: 'Fee structure, M-Pesa payment recording, student statements, defaulters list, bulk reminders.', bg: 'rgba(239,68,68,.15)', color: '#EF4444', tags: ['Auto-Record', 'Fee Statements', 'M-Pesa C2B'] },
        { icon: 'mdi mdi-school', title: 'Student Records', desc: 'Profiles, grades, class management, bulk promotions, report cards, alumni tracking.', bg: 'rgba(14,165,233,.15)', color: '#0EA5E9', tags: ['Grades', 'Promotions', 'Report Cards'] },
        { icon: 'mdi mdi-gavel', title: 'Discipline', desc: 'Log incidents, track resolutions, auto-notify parents by severity. Full audit trail.', bg: 'rgba(244,63,94,.15)', color: '#F43F5E', tags: ['Case Logging', 'Parent Alerts', 'Resolution'] },
        { icon: 'mdi mdi-message-text-fast', title: 'Bulk SMS', desc: 'Target entire school, specific class, campus, or individual parents. Schedule or send now.', bg: 'rgba(34,211,238,.15)', color: '#22D3EE', tags: ['Targeting', 'Scheduling', 'Delivery Reports'] },
        { icon: 'mdi mdi-contactless-payment', title: 'Pay on the Go', desc: 'Walk-in guests pay via M-Pesa STK Push. No card, no registration. Just a phone number.', bg: 'rgba(251,146,60,.15)', color: '#FB923C', tags: ['STK Push', 'Guest Payments', 'No Registration'] },
      ],

      flows: [
        { title: 'Attendance Tracking', icon: 'mdi mdi-map-marker', steps: [
            { icon: 'mdi mdi-card-account-details', title: 'Student Taps Card', desc: 'At the gate, classroom, bus, or event — student taps their RFID card on the reader.' },
            { icon: 'mdi mdi-crosshairs-gps', title: 'GPS Captured', desc: 'System captures the exact GPS coordinates — fixed for gates, live for buses.' },
            { icon: 'mdi mdi-message-text', title: 'SMS + Map Link', desc: 'Parent receives instant SMS: "John arrived at 7:38 AM" with a clickable Google Maps link.' },
            { icon: 'mdi mdi-email-newsletter', title: 'Daily Summary', desc: 'End-of-day email with full timeline — every tap, every location, any missed events flagged.' },
          ]},
        { title: 'Dining Payment', icon: 'mdi mdi-silverware-fork-knife', steps: [
            { icon: 'mdi mdi-card-account-details', title: 'Tap Card', desc: 'Student taps RFID card on the POS reader at any dining outlet.' },
            { icon: 'mdi mdi-account-check', title: 'Balance Shown', desc: 'Cashier sees student name, photo, and wallet balance instantly.' },
            { icon: 'mdi mdi-food', title: 'Select Meal', desc: 'Cashier picks fixed meal slot or individual items. Total computed.' },
            { icon: 'mdi mdi-check-circle', title: 'Done in 5 Seconds', desc: 'Amount deducted, receipt printed, SMS sent. Under 5 seconds total.' },
          ]},
        { title: 'Fee Payment', icon: 'mdi mdi-cash-register', steps: [
            { icon: 'mdi mdi-cellphone', title: 'Parent Pays', desc: 'Parent sends school fees via M-Pesa to the school\'s paybill using admission number.' },
            { icon: 'mdi mdi-sync', title: 'Auto-Recorded', desc: 'C2B callback matches payment to student automatically. Balance updated in real time.' },
            { icon: 'mdi mdi-message-text', title: 'SMS Receipt', desc: 'Parent receives SMS confirmation with amount paid, M-Pesa code, and remaining balance.' },
            { icon: 'mdi mdi-file-chart', title: 'Reports Ready', desc: 'School sees live fee dashboard — who paid, who owes, collection rates by class.' },
          ]},
      ],

      gpsTaps: [
        { title: 'School Gate Arrival', sms: '"John arrived at Greenfield School at 7:38 AM. Location: [GPS Link]"' },
        { title: 'Classroom Check-in', sms: '"John checked into Class 8A at 7:55 AM. Location: [GPS Link]"' },
        { title: 'School Gate Departure', sms: '"John left school at 3:45 PM. Location: [GPS Link]"' },
        { title: 'Bus Boarding', sms: '"John boarded Bus 2 (Karen Route) at 3:10 PM. Track: [GPS Link]"' },
        { title: 'Bus Drop-off', sms: '"John was dropped off at 4:20 PM. Location: [GPS Link]"' },
        { title: 'Event (Swimming)', sms: '"John checked into Swimming at 2:00 PM. Location: [GPS Link]"' },
      ],

      journey: [
        { stage: 'Class 1–8', label: 'Primary School', module: 'Home Finance', color: '#10B981', items: ['Earns from chores', 'Saves toward goals', 'Learns Spend/Save/Give'] },
        { stage: 'Form 1–4', label: 'High School', module: 'Pocket Money + Home Finance', color: '#2E86DE', items: ['Parent controls campus spend', 'Continues home saving', 'Card at school tuck shop'] },
        { stage: 'University', label: 'Higher Education', module: 'Dining Wallet', color: '#0D2B5E', items: ['Independent wallet', 'Tap to eat in 5 seconds', 'Peer-to-peer transfers'] },
      ],

      pricingPlans: [
        { name: 'Platform Fee', price: 'Custom', period: 'per institution', popular: false, headerBg: '#0F2347', cta: 'Get Started Free', features: ['Flexible per-school pricing', 'Negotiable rates', 'Free for pilot schools', 'All modules accessible', '500 free SMS on signup'] },
        { name: 'Attendance', price: 'KSh 1,000', period: 'per student / per term', popular: true, headerBg: '#0D2B5E', cta: 'Register Now', features: ['GPS tracking + SMS alerts', 'Gate, class, bus, events', 'Daily email summaries', 'Smart absence alerts', 'Biggest revenue driver'] },
        { name: 'SMS Credits', price: 'Prepaid', period: 'bundles via M-Pesa', popular: false, headerBg: '#0F2347', cta: 'View Bundles', features: ['500 free on signup', 'Self-service top-up', 'Admin allocation option', 'From KSh 0.50 per SMS', 'Never expires'] },
      ],

      faqs: [
        { q: 'How quickly can my school get started?', a: 'Immediately. Register on simitrac.co.ke, set up your campuses and classes, and you\'re live. No approval needed. You get 500 free SMS credits on registration.' },
        { q: 'Do parents need to install an app?', a: 'No. Parents receive all notifications via SMS — no app download required. However, the Simi Trac mobile app (coming soon) will give parents a richer experience with attendance timelines, spending analytics, and chore management.' },
        { q: 'What hardware do we need?', a: 'RFID/NFC card readers for gates and dining halls, a computer or tablet for the POS, a thermal receipt printer, and RFID cards for students. Schools with existing NFC student IDs can link those directly.' },
        { q: 'How does the GPS tracking work?', a: 'Fixed tap points (gates, classrooms) have GPS coordinates set during setup. Bus readers have built-in GPS modules that capture live coordinates. Every SMS includes a clickable Google Maps link.' },
        { q: 'Is there a contract or lock-in?', a: 'No contracts. No lock-in. Register for free, use the platform, and pay only when you see value. Billing is flexible and negotiated per institution.' },
        { q: 'How is student data protected?', a: 'Full multi-tenant isolation — each school\'s data is completely separate. Children\'s data is accessible only to their registered parents. All traffic is encrypted via HTTPS/TLS. RFID card UIDs are stored hashed.' },
        { q: 'Can we use Simi Trac for school fees only?', a: 'Yes. You can activate only the modules you need. Some schools start with fees and attendance, then add dining wallets later. The platform is fully modular.' },
      ],

      phoneTaps: [
        { icon: 'mdi mdi-door-open', title: 'Gate Arrival', sub: 'John arrived at school', time: '7:38 AM', bg: 'rgba(16,185,129,.15)', color: '#10B981' },
        { icon: 'mdi mdi-book-open-variant', title: 'Class Check-in', sub: 'Checked into Class 8A', time: '7:55 AM', bg: 'rgba(46,134,222,.15)', color: '#2E86DE' },
        { icon: 'mdi mdi-silverware-fork-knife', title: 'Lunch Payment', sub: 'KSh 150 at Dining Hall', time: '12:30 PM', bg: 'rgba(245,158,11,.15)', color: '#F59E0B' },
        { icon: 'mdi mdi-bus', title: 'Bus Boarding', sub: 'Bus 2 — Karen Route', time: '3:10 PM', bg: 'rgba(168,85,247,.15)', color: '#A855F7' },
      ],

      footerColumns: [
        { heading: 'Platform', links: [{ text: 'Attendance & GPS', url: '#attendance' }, { text: 'Dining Wallet', url: '#modules' }, { text: 'School Fees', url: '#modules' }, { text: 'Student Records', url: '#modules' }] },
        { heading: 'Resources', links: [{ text: 'Pricing', url: '#pricing' }, { text: 'FAQ', url: '#faq' }, { text: 'Login', url: '/login' }, { text: 'Register School', url: '/register' }] },
      ],
    };
  },
  computed: {
    currentYear() { return new Date().getFullYear(); },
    currentTime() {
      var d = new Date();
      var h = d.getHours();
      var m = d.getMinutes();
      var ampm = h >= 12 ? 'PM' : 'AM';
      h = h % 12; if (h === 0) h = 12;
      return h + ':' + (m < 10 ? '0' + m : m) + ' ' + ampm;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.checkLoginState();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() { this.isScrolled = window.scrollY > 50; },
    scrollTo(id) { var el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); },

    checkLoginState() {
      var loggedIn = sessionStorage.getItem('isLoggedIn');
      if (loggedIn) {
        this.isLoggedIn = true;
        var name = sessionStorage.getItem('userName') || '';
        this.userName = name;
        this.userInitials = this.getInitials(name);
        this.isPlatformOwner = (sessionStorage.getItem('userRole') || '') === 'platform_owner';
      }
    },

    logout() {
      sessionStorage.clear();
      localStorage.removeItem('authToken');
      this.isLoggedIn = false;
      this.userName = '';
      this.userInitials = '';
      this.showUserDrop = false;
      this.mobileMenuOpen = false;
      this.$router.push('/');
    },

    getInitials(name) {
      if (!name) return '?';
      var parts = name.trim().split(' ');
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.slice(0, 2).toUpperCase();
    },
  }
};
</script>

<style scoped>
/* ===== VARIABLES ===== */
:root { --st-bg: #0A1628; --st-card: #0F2347; --st-border: #1A3A6A; --st-primary: #2E86DE; --st-accent: #4FC3F7; --st-text: #E8EDF4; --st-muted: #8BA4C4; --st-dark: #060D1A; }

/* ===== NAVBAR ===== */
.st-nav { position:fixed; top:0; left:0; right:0; z-index:1050; padding:6px 0; transition:all .3s; background:transparent; }
.st-nav.nav-scrolled { background:rgba(10,22,40,.97); backdrop-filter:blur(20px); border-bottom:1px solid #1A3A6A; }
.st-nav-link { color:#8BA4C4!important; text-decoration:none; padding:8px 16px; font-size:14px; font-weight:500; transition:color .2s; }
.st-nav-link:hover { color:#4FC3F7!important; }
.st-nav-divider { width:1px; height:24px; background:#1A3A6A; margin:0 12px; display:inline-block; }
.st-btn-primary { background:linear-gradient(135deg,#2E86DE,#1A6BC4)!important; color:#fff!important; border:none; font-weight:600; border-radius:8px; padding:8px 20px; transition:all .2s; }
.st-btn-primary:hover { background:linear-gradient(135deg,#4FC3F7,#2E86DE)!important; transform:translateY(-1px); box-shadow:0 4px 20px rgba(46,134,222,.4); }
.st-btn-outline { border:1px solid #1A3A6A!important; color:#8BA4C4!important; background:transparent!important; border-radius:8px; padding:8px 20px; font-weight:500; transition:all .2s; }
.st-btn-outline:hover { border-color:#2E86DE!important; color:#4FC3F7!important; }
.st-btn-ghost { border:1px solid rgba(255,255,255,.2)!important; color:#E8EDF4!important; background:transparent!important; border-radius:8px; padding:8px 20px; font-weight:500; }
.st-btn-ghost:hover { border-color:#4FC3F7!important; color:#4FC3F7!important; }
.st-user-pill { display:flex; align-items:center; gap:8px; cursor:pointer; padding:4px 10px; border-radius:20px; border:1px solid #1A3A6A; position:relative; transition:all .2s; }
.st-user-pill:hover { border-color:#2E86DE; }
.st-avatar { width:28px; height:28px; border-radius:50%; background:rgba(46,134,222,.2); color:#4FC3F7; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; }
.st-user-name { color:#E8EDF4; font-size:13px; }
.st-user-drop { position:absolute; top:60px; right:20px; background:#0F2347; border:1px solid #1A3A6A; border-radius:10px; padding:8px 0; min-width:180px; z-index:200; box-shadow:0 8px 30px rgba(0,0,0,.5); }
.st-drop-item { display:flex; align-items:center; padding:8px 16px; color:#8BA4C4; text-decoration:none; font-size:13px; transition:all .2s; }
.st-drop-item:hover { background:rgba(46,134,222,.1); color:#E8EDF4; }
.st-mobile-menu { background:#0A1628; border-top:1px solid #1A3A6A; padding:16px 24px; }
.st-mobile-link { display:block; color:#8BA4C4!important; text-decoration:none; padding:12px 0; border-bottom:1px solid #1A3A6A; font-size:15px; }
.st-mobile-link:hover { color:#4FC3F7!important; }

/* ===== HERO ===== */
.st-hero { background:#0A1628; position:relative; overflow:hidden; }
.st-hero-grid { position:absolute; inset:0; background-image:linear-gradient(rgba(26,58,106,.15) 1px,transparent 1px),linear-gradient(90deg,rgba(26,58,106,.15) 1px,transparent 1px); background-size:60px 60px; }
.st-hero-glow { position:absolute; top:-30%; right:-10%; width:800px; height:800px; background:radial-gradient(circle,rgba(46,134,222,.12) 0%,transparent 60%); border-radius:50%; }
.st-hero-badge { background:rgba(46,134,222,.12); color:#4FC3F7; padding:6px 16px; border-radius:50px; font-size:13px; font-weight:600; display:inline-block; border:1px solid rgba(46,134,222,.2); }
.st-hero-title { font-size:54px; font-weight:800; line-height:1.08; color:#E8EDF4; letter-spacing:-1px; }
.st-hero-accent { background:linear-gradient(135deg,#2E86DE,#4FC3F7); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
.st-hero-sub { font-size:18px; line-height:1.7; color:#8BA4C4; max-width:540px; }
.st-hero-stats { display:flex; align-items:center; gap:0; flex-wrap:wrap; }
.st-hero-stat { text-align:center; padding:0 20px; }
.st-hero-stat-num { font-size:28px; font-weight:800; color:#4FC3F7; }
.st-hero-stat-lbl { font-size:12px; color:#8BA4C4; font-weight:500; margin-top:2px; }
.st-hero-stat-div { width:1px; height:40px; background:#1A3A6A; }

/* Phone Mockup */
.st-phone-mockup { width:280px; background:#0F2347; border-radius:32px; border:2px solid #1A3A6A; padding:12px; box-shadow:0 40px 80px rgba(0,0,0,.4),0 0 60px rgba(46,134,222,.1); position:relative; }
.st-phone-notch { width:100px; height:6px; background:#1A3A6A; border-radius:10px; margin:0 auto 12px; }
.st-phone-screen { background:#060D1A; border-radius:22px; padding:16px; min-height:380px; }
.st-phone-header { display:flex; align-items:center; gap:6px; margin-bottom:14px; padding-bottom:10px; border-bottom:1px solid #1A3A6A; }
.st-phone-time { margin-left:auto; color:#8BA4C4; font-size:11px; }
.st-phone-tap { display:flex; align-items:center; gap:10px; padding:10px; background:rgba(15,35,71,.6); border-radius:10px; margin-bottom:8px; border:1px solid #1A3A6A; animation:fadeSlideUp .5s ease both; }
.st-phone-tap-icon { width:36px; height:36px; border-radius:8px; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
.st-phone-map { text-align:center; padding:20px 0 10px; }
@keyframes fadeSlideUp { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }

/* ===== TRUSTED ===== */
.st-trusted { background:#060D1A; padding:30px 0; border-top:1px solid #1A3A6A; border-bottom:1px solid #1A3A6A; }
.st-trusted-label { color:#8BA4C4; font-size:12px; font-weight:600; letter-spacing:3px; margin-bottom:16px; }
.st-trusted-row { display:flex; justify-content:center; flex-wrap:wrap; gap:32px; }
.st-trusted-item { display:flex; align-items:center; gap:8px; color:#8BA4C4; font-size:14px; font-weight:500; }
.st-trusted-icon { font-size:22px; color:#2E86DE; }

/* ===== SECTIONS ===== */
.st-section { padding:80px 0; background:#0A1628; }
.st-section-label { color:#4FC3F7; font-size:12px; font-weight:700; letter-spacing:3px; text-transform:uppercase; }
.st-section-title { font-size:36px; font-weight:800; color:#E8EDF4; line-height:1.15; }
.st-section-sub { font-size:16px; color:#8BA4C4; line-height:1.7; }

/* Problem Cards */
.st-problem-card { background:#0F2347; border:1px solid #1A3A6A; border-radius:14px; padding:24px; height:100%; transition:all .3s; }
.st-problem-card:hover { border-color:#2E86DE; transform:translateY(-3px); }
.st-problem-icon { width:48px; height:48px; border-radius:12px; display:flex; align-items:center; justify-content:center; margin-bottom:14px; font-size:22px; }
.st-problem-title { color:#E8EDF4; font-weight:700; font-size:15px; margin-bottom:6px; }
.st-problem-desc { color:#8BA4C4; font-size:13px; line-height:1.6; margin:0; }

/* Module Cards */
.st-module-card { background:#0F2347; border:1px solid #1A3A6A; border-radius:16px; padding:28px; height:100%; transition:all .3s; cursor:default; }
.st-module-card:hover { border-color:#2E86DE; transform:translateY(-4px); box-shadow:0 12px 40px rgba(46,134,222,.12); }
.st-module-icon { width:56px; height:56px; border-radius:14px; display:flex; align-items:center; justify-content:center; margin-bottom:16px; }
.st-module-title { color:#E8EDF4; font-weight:700; font-size:17px; margin-bottom:8px; }
.st-module-desc { color:#8BA4C4; font-size:13px; line-height:1.6; margin-bottom:12px; }
.st-module-tags { display:flex; flex-wrap:wrap; gap:6px; }
.st-module-tag { background:rgba(46,134,222,.1); color:#4FC3F7; padding:3px 10px; border-radius:50px; font-size:11px; font-weight:600; }

/* Flow Tabs & Steps */
.st-flow-tab { background:#0F2347; border:1px solid #1A3A6A; color:#8BA4C4; border-radius:50px; padding:8px 20px; font-size:14px; font-weight:600; cursor:pointer; transition:all .2s; }
.st-flow-tab.active, .st-flow-tab:hover { background:rgba(46,134,222,.15); border-color:#2E86DE; color:#4FC3F7; }
.st-step-card { background:#0F2347; border:1px solid #1A3A6A; border-radius:16px; padding:28px 20px; text-align:center; position:relative; height:100%; }
.st-step-number { position:absolute; top:-14px; left:50%; transform:translateX(-50%); width:28px; height:28px; background:linear-gradient(135deg,#2E86DE,#4FC3F7); color:#fff; border-radius:50%; font-size:13px; font-weight:800; display:flex; align-items:center; justify-content:center; }
.st-step-icon { margin-bottom:14px; }
.st-step-title { color:#E8EDF4; font-weight:700; font-size:15px; margin-bottom:8px; }
.st-step-desc { color:#8BA4C4; font-size:12px; line-height:1.6; margin:0; }

/* GPS Section */
.st-gps-item { display:flex; align-items:flex-start; gap:14px; padding:14px 0; border-bottom:1px solid #1A3A6A; }
.st-gps-dot { width:10px; height:10px; border-radius:50%; border:2px solid #1A3A6A; flex-shrink:0; margin-top:5px; }
.st-gps-dot.active { background:#2E86DE; border-color:#2E86DE; }
.st-gps-title { color:#E8EDF4; font-size:14px; font-weight:600; }
.st-gps-sms { color:#8BA4C4; font-size:12px; line-height:1.5; margin-top:2px; font-style:italic; }

/* SMS Preview */
.st-sms-preview { background:#0F2347; border:1px solid #1A3A6A; border-radius:20px; padding:20px; max-width:360px; margin:0 auto; }
.st-sms-header { display:flex; align-items:center; gap:8px; color:#8BA4C4; font-size:14px; font-weight:600; padding-bottom:14px; border-bottom:1px solid #1A3A6A; margin-bottom:14px; }
.st-sms-bubble { background:#0A1628; border:1px solid #1A3A6A; border-radius:14px; padding:14px; margin-bottom:10px; color:#E8EDF4; font-size:13px; line-height:1.5; position:relative; }
.st-sms-link { color:#4FC3F7; font-size:12px; text-decoration:none; font-weight:600; }
.st-sms-link:hover { text-decoration:underline; color:#4FC3F7; }
.st-sms-time { color:#8BA4C4; font-size:10px; text-align:right; margin-top:6px; }
.st-sms-alert { border-color:rgba(255,107,107,.3); background:rgba(255,107,107,.05); color:#FF9999; }

/* Journey Cards */
.st-journey-card { background:#0F2347; border:1px solid #1A3A6A; border-radius:16px; padding:0; overflow:hidden; height:100%; }
.st-journey-bar { height:4px; }
.st-journey-stage { font-size:28px; font-weight:800; color:#E8EDF4; padding:24px 24px 0; }
.st-journey-label { color:#8BA4C4; font-size:13px; padding:2px 24px 16px; }
.st-journey-module { display:inline-block; color:#fff; font-size:11px; font-weight:700; padding:5px 14px; border-radius:50px; margin:0 24px 16px; }
.st-journey-list { list-style:none; padding:0 24px 24px; margin:0; }
.st-journey-list li { color:#8BA4C4; font-size:13px; padding:6px 0; border-top:1px solid #1A3A6A; }
.st-journey-list li:first-child { border-top:none; }

/* Pricing */
.st-pricing-card { background:#0F2347; border:1px solid #1A3A6A; border-radius:20px; overflow:hidden; position:relative; transition:all .3s; height:100%; }
.st-pricing-card:hover { border-color:#2E86DE; transform:translateY(-4px); }
.st-pricing-pop { border-color:#2E86DE!important; box-shadow:0 0 40px rgba(46,134,222,.15); }
.st-pricing-badge { position:absolute; top:-1px; left:50%; transform:translateX(-50%); background:linear-gradient(135deg,#2E86DE,#4FC3F7); color:#fff; padding:5px 18px; border-radius:0 0 12px 12px; font-size:10px; font-weight:800; letter-spacing:1px; }
.st-pricing-header { padding:30px 24px 20px; text-align:center; }
.st-pricing-name { color:#E8EDF4; font-weight:700; font-size:18px; margin-bottom:8px; }
.st-pricing-price { color:#4FC3F7; font-size:32px; font-weight:800; }
.st-pricing-period { color:#8BA4C4; font-size:12px; margin-top:4px; }
.st-pricing-body { padding:20px 24px 28px; }
.st-pricing-feature { display:flex; align-items:center; gap:10px; color:#E8EDF4; font-size:13px; padding:8px 0; }
.st-pricing-example { background:#0F2347; border:1px solid #1A3A6A; border-radius:12px; padding:16px 24px; color:#8BA4C4; font-size:14px; text-align:center; }

/* FAQ */
.st-faq-item { background:#0F2347; border:1px solid #1A3A6A; border-radius:12px; margin-bottom:10px; overflow:hidden; cursor:pointer; transition:all .2s; }
.st-faq-item:hover { border-color:#2E86DE; }
.st-faq-q { display:flex; align-items:center; justify-content:space-between; padding:16px 20px; color:#E8EDF4; font-size:15px; font-weight:600; }
.st-faq-q i { color:#4FC3F7; font-size:20px; flex-shrink:0; }
.st-faq-a { padding:0 20px 16px; color:#8BA4C4; font-size:14px; line-height:1.7; }

/* CTA */
.st-cta { background:linear-gradient(135deg,#0D2B5E 0%,#1A6BC4 50%,#0D2B5E 100%); padding:80px 0; position:relative; overflow:hidden; }
.st-cta::before { content:''; position:absolute; inset:0; background-image:linear-gradient(rgba(255,255,255,.03) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.03) 1px,transparent 1px); background-size:40px 40px; }
.st-cta-title { font-size:36px; font-weight:800; color:#fff; position:relative; z-index:1; }
.st-cta-sub { font-size:18px; color:rgba(255,255,255,.7); position:relative; z-index:1; }

/* Footer */
.st-footer { background:#060D1A; padding:60px 0 0; border-top:1px solid #1A3A6A; }
.st-footer-desc { color:#8BA4C4; font-size:14px; line-height:1.7; max-width:300px; }
.st-footer-socials { display:flex; gap:8px; margin-top:16px; }
.st-social-icon { width:36px; height:36px; background:#0F2347; border:1px solid #1A3A6A; border-radius:8px; display:flex; align-items:center; justify-content:center; color:#8BA4C4; font-size:18px; text-decoration:none; transition:all .2s; }
.st-social-icon:hover { border-color:#2E86DE; color:#4FC3F7; }
.st-footer-heading { color:#E8EDF4; font-size:14px; font-weight:700; margin-bottom:16px; text-transform:uppercase; letter-spacing:1px; }
.st-footer-link { display:block; color:#8BA4C4; text-decoration:none; font-size:14px; padding:5px 0; transition:color .2s; }
.st-footer-link:hover { color:#4FC3F7; }
.st-footer-bottom { display:flex; justify-content:space-between; align-items:center; padding:24px 0; margin-top:40px; border-top:1px solid #1A3A6A; color:#8BA4C4; font-size:13px; }

/* ===== RESPONSIVE ===== */
@media(max-width:991px) { .st-hero-title { font-size:40px; } .st-section-title { font-size:28px; } }
@media(max-width:575px) { .st-hero-title { font-size:32px; } .st-hero-sub { font-size:15px; } .st-section-title { font-size:24px; } .st-hero-stats { gap:0; } .st-hero-stat { padding:0 12px; } .st-footer-bottom { flex-direction:column; gap:8px; text-align:center; } }
</style>